import { jsx as o, jsxs as x } from "react/jsx-runtime";
import { useState as s, useEffect as h } from "react";
import { useSpring as c, animated as p } from "@react-spring/web";
import { T as S } from "./Typography-HkIo7ajX.js";
import { T as I } from "./TextFormatter-BVdWjwiB.js";
const b = ({ thickness: t = 10, color: r = "currentColor", height: e = "1em" }) => {
  const i = c({
    opacity: 1,
    from: { opacity: 0 },
    loop: !0,
    config: { duration: 800 }
  });
  return /* @__PURE__ */ o(
    p.span,
    {
      "data-testid": "type-loading",
      style: {
        ...i,
        display: "inline-block",
        width: t,
        height: e,
        backgroundColor: r,
        verticalAlign: "middle"
      }
    }
  );
}, A = ({
  text: t,
  onComplete: r = () => {
  },
  speed: e = 50,
  variant: i = "text",
  loadingOptions: d = {},
  ...l
}) => {
  const [m, u] = s(""), [n, y] = s(0), f = c({
    opacity: 1,
    from: { opacity: 0 },
    config: { duration: 100 }
  });
  return h(() => {
    if (n >= t.length) {
      r();
      return;
    }
    const g = 1e3 / e, T = setTimeout(() => {
      u((a) => a + t[n]), y((a) => a + 1);
    }, g);
    return () => {
      clearTimeout(T);
    };
  }, [n, t, e, r]), /* @__PURE__ */ o(
    S,
    {
      variant: i,
      ...l,
      children: /* @__PURE__ */ x(p.span, { style: f, children: [
        /* @__PURE__ */ o(I, { text: m }),
        /* @__PURE__ */ o(b, { ...d })
      ] })
    }
  );
};
export {
  A as T,
  b as a
};
